import React, { Component } from 'react'
import PropTypes from 'prop-types'
import {
  Table,
  Popconfirm,
  Button,
  AutoComplete,
  Icon,
  Radio,
  Select,
  Spin,
  Form,
  InputNumber,
  Input
} from 'antd'
import styled from 'styled-components'
import { convertToTemplateOption, convertToOption } from '../util'
const AddItemArea = styled.div`
  padding-top: 10px;
  padding-right: 10px;
  padding-bottom: 10px;
`
const { TextArea } = Input
const { Column } = Table
const Option = Select.Option
const FormItem = Form.Item
const EditableCell = ({ editable, value, onChange }) => (
  <div>
    {editable ? (
      <Input style={{ margin: '-5px 0' }} value={value} onChange={e => onChange(e.target.value)} />
    ) : (
      value
    )}
  </div>
)

const propTypes = {
  estimateItems: PropTypes.array,
  loadingEstimateItems: PropTypes.bool.isRequired
}

class ChangeOrderView extends Component {
  constructor(props) {
    super(props)
    this.state = {
      estimateGrandTotal: props.estimateGrandTotal
    }
  }
  componentDidUpdate() {
    if (!this.props.modalVisible) {
      const form = this.props.form
      form.resetFields()
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      (!this.props.modalVisible && nextProps.modalVisible) ||
      this.props.estimateGrandTotal !== nextProps.estimateGrandTotal
    ) {
      this.setState({
        estimateGrandTotal: nextProps.estimateGrandTotal
      })
    }
  }

  handleCheckboxChange = event => {
    console.log('event', event.target.name)
    console.log('event', event.target.checked)
  }

  renderColumns(text, record, column) {
    return (
      <EditableCell
        editable={record.isEditingRow}
        value={text}
        onChange={value => this.props.handleInputChange(value, record.id, column)}
      />
    )
  }

  handleTemplateChange = templateId => {
    let selectedItem = []
    if (this.props.title === 'Job Site Repair Orders') {
      selectedItem = this.props.repairOrderTemplates.find(
        row => parseInt(row.id, 0) === parseInt(templateId, 0)
      )
    } else {
      selectedItem = this.props.changeOrderTemplates.find(
        row => parseInt(row.id, 0) === parseInt(templateId, 0)
      )
    }
    if (selectedItem) {
      let changeTemplate = false

      if (this.props.isEditing) {
        if (
          window.confirm(
            'Are you sure you want to change the template? By doing so you will lose all data currently on the screen.'
          )
        ) {
          changeTemplate = true
        }
      } else {
        changeTemplate = true
      }

      if (changeTemplate) {
        this.props.setChangeOrderItems(selectedItem.tasks)
        this.props.setSelectedTemplate(selectedItem)
      }
    }
  }

  renderRadio(text, record, column) {
    if (record.isEditingRow) {
      return (
        <Radio.Group
          value={text}
          onChange={event => this.props.handleInputChange(event.target.value, record.id, 'type')}
        >
          <Radio.Button value="add">Add</Radio.Button>
          <Radio.Button value="deduct">Deduct</Radio.Button>
        </Radio.Group>
      )
    } else {
      return <div>{text}</div>
    }
  }

  render() {
    const {
      changeOrderItems,
      estimateName,
      estimateList,
      handleEstimateChange,
      revisions,
      loadingRevision,
      handleRevisionChange,
      isEditing,
      title,
      repairOrderTemplates,
      changeOrderTemplates,
      selectedTemplate,
      estimateItems,
      loadingEstimateItems,
      estimateSelectedItem,
      isRepairOrder
    } = this.props

    const { estimateGrandTotal } = this.state

    const { getFieldDecorator } = this.props.form

    return (
      <div>
        <Form layout="vertical">
          <div className="row">
            <div className="col-md-3">
              <AddItemArea>
                <FormItem label="Estimate">
                  {getFieldDecorator('estimate_id', {
                    rules: [
                      {
                        required: true,
                        message: 'Choose an Esimate'
                      }
                    ],
                    initialValue: estimateName
                  })(
                    <AutoComplete
                      dataSource={convertToTemplateOption(estimateList)}
                      filterOption={(inputValue, option) =>
                        option.props.children.toUpperCase().indexOf(inputValue.toUpperCase()) !== -1
                      }
                      onChange={handleEstimateChange}
                    >
                      <Input suffix={<Icon type="search" className="certain-category-icon" />} />
                    </AutoComplete>
                  )}
                </FormItem>
              </AddItemArea>
            </div>
            {isEditing && (
              <div className="col-md-3">
                <AddItemArea>
                  <div style={{ marginBottom: '1em' }}>Revision</div>
                  {loadingRevision ? (
                    <Spin size="small" />
                  ) : (
                    <Select
                      defaultValue={
                        revisions && revisions.length > 0
                          ? revisions[revisions.length - 1].id
                          : null
                      }
                      onChange={handleRevisionChange}
                      style={{ width: 120 }}
                    >
                      {revisions &&
                        revisions.map(revision => (
                          <Option key={revision.id} value={revision.id}>
                            {revision.revision}
                          </Option>
                        ))}
                    </Select>
                  )}
                </AddItemArea>
              </div>
            )}
            <div className="col-md-3" />
            {estimateItems &&
              !loadingEstimateItems && (
                <div className="col-md-3 text-right">
                  <h4>Grand Total: </h4>
                  <InputNumber
                    value={estimateGrandTotal}
                    onChange={value =>
                      this.setState({
                        estimateGrandTotal: value
                      })
                    }
                    formatter={value => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                    parser={value => value.replace(/\$\s?|(,*)/g, '')}
                    onBlur={e => this.props.onBlurGrandTotal(e)}
                  />
                </div>
              )}
          </div>
          <div className="row">
            <div className="col-md-6 mb-2">
              <FormItem label="Template">
                {getFieldDecorator('template_id', {
                  rules: [
                    {
                      required: true,
                      message: 'Choose a Template'
                    }
                  ],
                  initialValue: selectedTemplate ? selectedTemplate.name : null
                })(
                  <AutoComplete
                    dataSource={
                      title === 'Job Site Change Orders'
                        ? convertToOption(changeOrderTemplates)
                        : convertToOption(repairOrderTemplates)
                    }
                    filterOption={(inputValue, option) => {
                      if (option.props.children) {
                        return (
                          option.props.children.toUpperCase().indexOf(inputValue.toUpperCase()) !==
                          -1
                        )
                      } else {
                        return ''
                      }
                    }}
                    onSelect={templateId => this.handleTemplateChange(templateId)}
                  >
                    <Input suffix={<Icon type="search" className="certain-category-icon" />} />
                  </AutoComplete>
                )}
              </FormItem>
            </div>
          </div>
          {isRepairOrder && (
            <div>
              <div className="row">
                <div className="col-md-12">
                  <FormItem label="Scope of work">
                    {getFieldDecorator('scope_of_work', {
                      initialValue: this.props.scopeOfWork ? this.props.scopeOfWork : ''
                    })(
                      <TextArea
                        placeholder="Describe the scope of work..."
                        onChange={this.props.handleScopeOfWorkChange}
                        rows={4}
                      />
                    )}
                  </FormItem>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <FormItem label="Schedule">
                    {getFieldDecorator('schedule', {
                      initialValue: this.props.schedule ? this.props.schedule : ''
                    })(
                      <TextArea
                        placeholder="Describe the schedule..."
                        onChange={this.props.handleScheduleChange}
                        rows={4}
                      />
                    )}
                  </FormItem>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <FormItem label="Payment Schedule">
                    {getFieldDecorator('payment_schedule', {
                      initialValue: this.props.payment_schedule ? this.props.payment_schedule : ''
                    })(
                      <TextArea
                        placeholder="Describe the payment schedule..."
                        onChange={this.props.handlePaymentScheduleChange}
                        rows={4}
                      />
                    )}
                  </FormItem>
                </div>
              </div>
            </div>
          )}
          {loadingEstimateItems && !estimateItems && <Spin spinning={loadingEstimateItems} />}
          {estimateItems &&
            !loadingEstimateItems &&
            !isRepairOrder && (
              <div>
                <div className="row">
                  <div className="col-md-12">
                    <div>Items</div>
                    <Table
                      dataSource={changeOrderItems}
                      size="small"
                      bordered
                      // title={title}
                      pagination={false}
                      rowKey="id"
                    >
                      <Column
                        title="Name"
                        dataIndex="name"
                        key="name"
                        width={250}
                        render={(text, record) => this.renderColumns(text, record, 'name')}
                      />
                      <Column
                        title="Description"
                        dataIndex="description"
                        key="description"
                        render={(text, record) => this.renderColumns(text, record, 'description')}
                      />
                      <Column
                        title="Type"
                        dataIndex="type"
                        key="type"
                        width={160}
                        render={(text, record) => this.renderRadio(text, record, 'type')}
                      />
                      <Column
                        title=" "
                        dataIndex="action"
                        key="action"
                        render={(text, record) => {
                          return (
                            <div>
                              {record.isEditingRow && (
                                <Button icon="save" onClick={() => this.props.saveRow(record.id)} />
                              )}
                              {!record.isEditingRow && (
                                <Button icon="edit" onClick={() => this.props.editRow(record.id)} />
                              )}
                              <Button
                                icon="caret-up"
                                className="marginLeft5"
                                onClick={() => this.props.moveItemUp(record.id)}
                              />
                              <Button
                                icon="caret-down"
                                onClick={() => this.props.moveItemDown(record.id)}
                              />
                              <Popconfirm
                                title="Are you sure you want to delete this line?"
                                onConfirm={() => this.props.deleteRow(record.id)}
                                onCancel={this.cancelDelete}
                                okText="Yes"
                                cancelText="No"
                              >
                                <Button className="marginLeft5" type="danger" icon="delete" />
                              </Popconfirm>
                            </div>
                          )
                        }}
                        width={160}
                      />
                    </Table>
                  </div>
                </div>
                <AddItemArea>
                  <div className="row">
                    <div className="col-md-3">
                      <Select
                        showSearch
                        style={{ width: 200 }}
                        placeholder="Search an item"
                        optionFilterProp="children"
                        onChange={value => this.props.handleAddItemInputChange(value)}
                        filterOption={(input, option) =>
                          option.props.children.toLowerCase().includes(input.toLowerCase())
                        }
                        value={estimateSelectedItem && estimateSelectedItem.id}
                      >
                        {this.props.estimateItems.map(item => (
                          <Option key={item.id} value={item.id} title={item.name}>
                            {item.name}
                          </Option>
                        ))}
                      </Select>
                    </div>
                    <div className="col-md-4">
                      <Input
                        placeholder="Change order description..."
                        value={this.props.addDescriptionInput}
                        onChange={event =>
                          this.props.handleAddDescriptionInputChange(event.target.value)
                        }
                      />
                    </div>
                    <div className="col-md-3">
                      <Radio.Group
                        value={this.props.addTypeInput}
                        onChange={event => this.props.handleAddTypeInputChange(event.target.value)}
                      >
                        <Radio.Button value="add">Add</Radio.Button>
                        <Radio.Button value="deduct">Deduct</Radio.Button>
                      </Radio.Group>
                    </div>
                    <div className="col-md-2 text-right">
                      <Button onClick={() => this.props.handleAddItemClick()}>Add Item</Button>
                    </div>
                  </div>
                </AddItemArea>
              </div>
            )}
        </Form>
      </div>
    )
  }
}

ChangeOrderView.propTypes = propTypes

export default Form.create()(ChangeOrderView)



// WEBPACK FOOTER //
// ./src/components/ChangeOrderView.js